/* TestHelden · Für Unternehmen (/pages/unternehmen): Kurswahl, Staffelrechner, Formular an /api/b2b/entwurf.
   Preise sind nur Anzeige; die Plattform rechnet neu. Shop-Preise sind inkl. USt (taxesIncluded), befreite Kurse
   (§ 4 Nr. 21 UStG) haben variant.taxable = false.
   Vertrag = Plattform-Code apps/web/lib/b2b/teamlizenz/anfrage.ts (POST /api/mobile/b2b/entwurf):
     Felder art, firma, vorname, nachname, email, telefon, nachricht, variantId, anzahl, zahlweg (sofort|rechnung),
     unternehmerBestaetigt, bedingungenAkzeptiert, strasse, plz, ort, land, ustId, bestellnummer,
     oeffentlicheEinrichtung, website (Honeypot), formStart (ms, mind. 3 s vor dem Absenden).
     Antwort { ok, modus: entwurf|anfrage, referenz, zahlweg, checkoutUrl?, meldung } bzw. { ok:false, fehler, feld }. */
(function () {
  'use strict';
  if (window.__thuInit) return;
  window.__thuInit = 1;

  var EU = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];
  var EUR = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  function euro(c) { return EUR.format(Math.round(c) / 100); }
  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }

  function staffelLesen(roh) {
    return String(roh || '').split(/[\n,;]+/).map(function (z) {
      var t = z.split(':');
      if (t.length < 2) return null;
      var ab = parseInt(t[0], 10);
      var w = String(t[1]).trim();
      if (!ab) return null;
      return { ab: ab, angebot: w === 'angebot', rabatt: w === 'angebot' ? 0 : parseFloat(w.replace(',', '.')) || 0 };
    }).filter(Boolean).sort(function (a, b) { return a.ab - b.ab; });
  }

  function init(root) {
    var form = $(root, '[data-thu-form]');
    var staffel = staffelLesen(root.getAttribute('data-staffel'));
    var minMenge = parseInt(root.getAttribute('data-mindestmenge'), 10) || 5;
    var ustSatz = (parseFloat(root.getAttribute('data-ust')) || 19) / 100;
    var endpunkt = root.getAttribute('data-endpunkt');
    var mail = root.getAttribute('data-mail') || 'support@testhelden.com';
    var sec = root.closest('section');
    var modus = 'teamlizenz';
    var produkt = null;
    var variante = null;
    var aktion = 'bezahlen';
    var sendet = false;
    var formStart = Date.now();

    var suche = $(root, '[data-thu-suche]');
    var treffer = $(root, '[data-thu-treffer]');
    var paket = $(root, '[data-thu-paket]');
    var anzahl = $(root, '[data-thu-anzahl]');
    var land = $(root, '[data-thu-land]');
    var ustid = $(root, '[data-thu-ustid]');
    var status = $(root, '[data-thu-status]');

    /* ---------- Modus (Teamlizenz | Assessment) ---------- */
    function modusSetzen(m, fokus) {
      modus = m;
      form.elements.art.value = m;
      $$(root, '[data-thu-modus]').forEach(function (b) {
        var an = b.getAttribute('data-thu-modus') === m;
        b.setAttribute('aria-selected', an ? 'true' : 'false');
        b.tabIndex = an ? 0 : -1;
        if (an && fokus) b.focus();
      });
      $$(root, '[data-nur]').forEach(function (el) {
        var sichtbar = el.getAttribute('data-nur') === m;
        el.hidden = !sichtbar;
        $$(el, 'input,select,textarea').forEach(function (i) { i.disabled = !sichtbar; });
      });
      root.classList.toggle('thu-strecke--assessment', m === 'assessment');
      rechnen();
    }
    $$(root, '[data-thu-modus]').forEach(function (b) {
      b.addEventListener('click', function () { modusSetzen(b.getAttribute('data-thu-modus')); });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); modusSetzen(modus === 'teamlizenz' ? 'assessment' : 'teamlizenz', true); }
      });
    });
    // Sprunglinks auf der Seite: #assessment-anfrage öffnet den Assessment-Modus, #bestellen die Teamlizenzen
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var h = a.getAttribute('href').split('#')[1];
      if (h === 'assessment-anfrage' || h === 'bestellen') {
        e.preventDefault();
        modusSetzen(h === 'assessment-anfrage' ? 'assessment' : 'teamlizenz');
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + h);
      }
    });

    /* ---------- Kurssuche ---------- */
    var suchTimer = null;
    var suchNr = 0;
    var aktiv = -1;
    function trefferZeigen(liste) {
      treffer.innerHTML = '';
      aktiv = -1;
      if (!liste.length) {
        var li = document.createElement('li');
        li.className = 'thu-suche__leer';
        li.textContent = 'Kein Online-Testtrainer gefunden. Versuchen Sie einen anderen Begriff, z. B. den Beruf.';
        treffer.appendChild(li);
      }
      liste.forEach(function (p, i) {
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.id = treffer.id + '-' + i;
        li.className = 'thu-suche__eintrag';
        li.setAttribute('data-handle', p.handle);
        if (p.image) {
          var img = document.createElement('img');
          img.src = p.image + (p.image.indexOf('?') > -1 ? '&' : '?') + 'width=80';
          img.alt = ''; img.width = 40; img.height = 40; img.loading = 'lazy';
          li.appendChild(img);
        }
        var sp = document.createElement('span');
        sp.textContent = kurzTitel(p.title);
        li.appendChild(sp);
        li.addEventListener('mousedown', function (e) { e.preventDefault(); kursLaden(p.handle); });
        treffer.appendChild(li);
      });
      treffer.hidden = false;
      suche.setAttribute('aria-expanded', 'true');
    }
    function trefferZu() { treffer.hidden = true; suche.setAttribute('aria-expanded', 'false'); suche.removeAttribute('aria-activedescendant'); }
    function kurzTitel(t) { return String(t || '').replace(/\s+[–-]\s+Online[\s-]Testtrainer\s*$/i, '').replace(/\s+20\d\d\s+üben$/i, '').replace(/\s+20\d\d/, '').trim(); }
    function istTrainer(t) { return /testtrainer/i.test(t || ''); }
    suche.addEventListener('input', function () {
      var q = suche.value.trim();
      clearTimeout(suchTimer);
      if (q.length < 2) { trefferZu(); return; }
      suchTimer = setTimeout(function () {
        var nr = ++suchNr;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide';
        fetch(url, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
          if (nr !== suchNr) return;
          var ps = (((d || {}).resources || {}).results || {}).products || [];
          trefferZeigen(ps.filter(function (p) { return istTrainer(p.title); }).slice(0, 8));
        }).catch(function () { if (nr === suchNr) trefferZu(); });
      }, 220);
    });
    suche.addEventListener('keydown', function (e) {
      var opts = $$(treffer, '[role="option"]');
      if (treffer.hidden || !opts.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        aktiv = (aktiv + (e.key === 'ArrowDown' ? 1 : -1) + opts.length) % opts.length;
        opts.forEach(function (o, i) { o.classList.toggle('ist-aktiv', i === aktiv); o.setAttribute('aria-selected', i === aktiv ? 'true' : 'false'); });
        suche.setAttribute('aria-activedescendant', opts[aktiv].id);
      } else if (e.key === 'Enter') {
        e.preventDefault();
        kursLaden(opts[aktiv > -1 ? aktiv : 0].getAttribute('data-handle'));
      } else if (e.key === 'Escape') { trefferZu(); }
    });
    suche.addEventListener('blur', function () { setTimeout(trefferZu, 120); });
    $$(root, '[data-thu-kurs]').forEach(function (b) {
      b.addEventListener('click', function () { kursLaden(b.getAttribute('data-thu-kurs')); });
    });
    $(root, '[data-thu-kurs-wechseln]').addEventListener('click', function () {
      produkt = null; variante = null;
      form.elements.kurs_handle.value = '';
      $(root, '[data-thu-kurs-karte]').hidden = true;
      $(root, '.thu-suche').hidden = false;
      var chips = $(root, '.thu-chips'); if (chips) chips.hidden = false;
      $(root, '[data-thu-paket-feld]').hidden = true;
      $$(root, '[data-thu-kurs]').forEach(function (c) { c.classList.remove('is-active'); });
      rechnen();
      suche.value = ''; suche.focus();
    });

    function kursLaden(handle, varianteId) {
      if (!handle) return;
      trefferZu();
      fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (p) {
          var vs = (p.variants || []).filter(function (v) { return v.available !== false && !v.requires_shipping; });
          if (!vs.length || !istTrainer(p.title)) throw new Error('kein Trainer');
          produkt = p;
          produkt.vs = vs;
          form.elements.kurs_handle.value = p.handle;
          var karte = $(root, '[data-thu-kurs-karte]');
          $(root, '[data-thu-kurs-titel]').textContent = kurzTitel(p.title);
          var bild = $(root, '[data-thu-kurs-bild]');
          if (p.featured_image) { bild.src = (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=192'; bild.alt = ''; bild.hidden = false; } else { bild.hidden = true; }
          karte.hidden = false;
          $(root, '.thu-suche').hidden = true;
          var chips = $(root, '.thu-chips'); if (chips) chips.hidden = true;
          paket.innerHTML = '';
          vs.forEach(function (v) {
            var o = document.createElement('option');
            o.value = v.id;
            o.textContent = (v.public_title || v.title) + ' · ' + euro(v.price) + ' im Shop';
            paket.appendChild(o);
          });
          var start = vs.filter(function (v) { return String(v.id) === String(varianteId); })[0] || vs[0];
          paket.value = start.id;
          variante = start;
          $(root, '[data-thu-paket-feld]').hidden = vs.length < 2;
          var shopLink = $(root, '[data-thu-shop-link]');
          if (shopLink) shopLink.href = '/products/' + p.handle + '?variant=' + start.id;
          $$(root, '[data-thu-kurs]').forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-thu-kurs') === p.handle); });
          fehlerSetzen('kurs_handle', '');
          rechnen();
        })
        .catch(function () { fehlerSetzen('kurs_handle', 'Dieser Kurs lässt sich gerade nicht laden. Bitte wählen Sie ihn erneut oder schreiben Sie uns.'); });
    }
    paket.addEventListener('change', function () {
      if (!produkt) return;
      variante = produkt.vs.filter(function (v) { return String(v.id) === paket.value; })[0] || produkt.vs[0];
      var shopLink = $(root, '[data-thu-shop-link]');
      if (shopLink) shopLink.href = '/products/' + produkt.handle + '?variant=' + variante.id;
      rechnen();
    });

    /* ---------- Anzahl ---------- */
    function menge() { var n = parseInt(anzahl.value, 10); return isNaN(n) ? 0 : n; }
    $$(root, '[data-thu-menge]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, Math.min(9999, menge() + parseInt(b.getAttribute('data-thu-menge'), 10)));
        anzahl.value = n;
        rechnen();
      });
    });
    anzahl.addEventListener('input', rechnen);
    anzahl.addEventListener('blur', function () { if (menge() < 1) anzahl.value = minMenge; rechnen(); });
    land.addEventListener('change', rechnen);
    ustid.addEventListener('input', rechnen);

    /* ---------- Rechner ---------- */
    // EU-Firmen außerhalb DE mit USt-IdNr. dürfen auch 1–4 Lizenzen ohne USt bestellen (Plattform: rcEinzel)
    function rcEinzel() {
      var id = (ustid.value || '').replace(/[\s.-]/g, '').toUpperCase();
      return land.value !== 'DE' && EU.indexOf(land.value) > -1 && id.length >= 4;
    }
    function stufe(n) {
      var s = null;
      staffel.forEach(function (t) { if (n >= t.ab) s = t; });
      return s;
    }
    // Wie steuerfallFuer() in lib/b2b/teamlizenz/preis.ts: inland | befreit | reverse_charge | eu_ohne_ustid | drittland
    function steuerfall(befreit) {
      var l = land.value;
      var id = (ustid.value || '').replace(/[\s.-]/g, '').toUpperCase();
      if (l === 'DE' || l === '') return befreit ? { fall: 'befreit', satz: 0, text: 'umsatzsteuerfrei nach § 4 Nr. 21 UStG' } : { fall: 'inland', satz: ustSatz, text: 'zzgl. ' + Math.round(ustSatz * 100) + ' % USt.' };
      if (EU.indexOf(l) > -1) {
        if (/^[A-Z]{2}[0-9A-Z]{2,13}$/.test(id) && id.slice(0, 2) !== 'DE') return { fall: 'reverse_charge', satz: 0, text: 'USt. (Reverse-Charge, nach Prüfung der USt-IdNr.)' };
        return { fall: 'eu_ohne_ustid', satz: 0, text: 'USt. (klären wir im Angebot)', anfrage: true };
      }
      return { fall: 'drittland', satz: 0, text: 'ohne deutsche USt.', anfrage: true };
    }
    function rechnen() {
      var n = menge();
      var st = stufe(n);
      $$(sec, '[data-thu-staffel-liste] .thu-staffel__stufe').forEach(function (li) {
        li.classList.toggle('ist-aktiv', modus === 'teamlizenz' && !!st && parseInt(li.getAttribute('data-ab'), 10) === st.ab);
      });
      var klein = $(root, '[data-thu-klein]');
      var sfVorab = produkt && variante ? steuerfall(variante.taxable === false) : steuerfall(false);
      var nurAnfrage = modus === 'teamlizenz' && !!sfVorab.anfrage;
      var istAngebot = !!(st && st.angebot);
      var zuWenig = n > 0 && n < minMenge && !rcEinzel();
      if (klein) klein.hidden = !(modus === 'teamlizenz' && zuWenig && produkt);
      $(root, '[data-thu-knoepfe-kauf]').hidden = modus !== 'teamlizenz' || istAngebot || nurAnfrage;
      $(root, '[data-thu-knoepfe-anfrage]').hidden = modus === 'teamlizenz' && !istAngebot && !nurAnfrage;
      var sfHinweis = $(root, '[data-thu-steuer-hinweis]');
      if (sfHinweis) sfHinweis.hidden = !nurAnfrage;
      $(root, '[data-thu-anfrage-text]').textContent = modus === 'assessment' ? 'Demo und Angebot anfragen' : 'Angebot anfordern';

      var leer = $(root, '[data-thu-summe-leer]');
      var inhalt = $(root, '[data-thu-summe-inhalt]');
      if (!produkt || !variante || modus !== 'teamlizenz') { leer.hidden = false; inhalt.hidden = true; return; }
      leer.hidden = true; inhalt.hidden = false;
      var befreit = variante.taxable === false;
      var sf = steuerfall(befreit);
      var brutto = variante.price; // Cent, inkl. USt
      var normalNetto = befreit ? brutto : brutto / (1 + ustSatz);
      var r = st && !st.angebot ? st.rabatt / 100 : 0;
      var jeBruttoCent = Math.round(brutto * (1 - r));
      var jeNetto = befreit ? jeBruttoCent : jeBruttoCent / (1 + ustSatz);
      // Wie die Kasse (Preise inkl. USt): Brutto je Lizenz × Anzahl, daraus Netto und USt; ohne USt nur Netto.
      var summeNetto, ust, ersparnis;
      if (sf.satz > 0) { var summeBrutto = jeBruttoCent * Math.max(n, 0); summeNetto = Math.round(summeBrutto / (1 + sf.satz)); ust = summeBrutto - summeNetto; ersparnis = Math.round((normalNetto - jeNetto) * Math.max(n, 0)); }
      else {
        // Wie lib/b2b/teamlizenz/preis.ts: Netto-Einzelpreis runden, Staffel darauf, × Anzahl
        var einzelNetto = befreit ? brutto : Math.round(brutto / (1 + ustSatz));
        jeNetto = Math.round(einzelNetto * (1 - r));
        summeNetto = jeNetto * Math.max(n, 0); ust = 0;
        ersparnis = (einzelNetto - jeNetto) * Math.max(n, 0);
      }

      $(root, '[data-thu-s-kurs]').textContent = kurzTitel(produkt.title) + (produkt.vs.length > 1 ? ' · ' + (variante.public_title || variante.title) : '');
      $(root, '[data-thu-s-normal]').textContent = euro(normalNetto) + (befreit ? '' : ' netto');
      $(root, '[data-thu-s-rabatt]').textContent = istAngebot ? 'individuell' : (r > 0 ? '−' + st.rabatt.toLocaleString('de-DE') + ' %' : (zuWenig ? 'ab ' + minMenge + ' Lizenzen' : '–'));
      $(root, '[data-thu-s-je-art]').textContent = befreit ? '' : 'netto';
      $(root, '[data-thu-s-je]').textContent = istAngebot ? 'auf Anfrage' : euro(jeNetto);
      $(root, '[data-thu-s-anzahl]').textContent = n.toLocaleString('de-DE');
      $(root, '[data-thu-s-netto]').textContent = istAngebot ? '–' : euro(summeNetto);
      $(root, '[data-thu-s-ust-text]').textContent = sf.text;
      $(root, '[data-thu-s-ust]').textContent = istAngebot ? '–' : euro(ust);
      $(root, '[data-thu-s-brutto]').textContent = istAngebot ? 'Angebot' : euro(summeNetto + ust);
      $(root, '[data-thu-s-ersparnis]').textContent = euro(ersparnis);
      $(root, '[data-thu-s-ersparnis-zeile]').hidden = istAngebot || ersparnis <= 0;
      $(root, '[data-thu-s-angebot]').hidden = !istAngebot;
      if (nurAnfrage && !istAngebot) $(root, '[data-thu-s-ersparnis-zeile]').hidden = true;
      $(root, '[data-thu-s-fuss]').textContent = istAngebot ? '' : 'Verbindlich ist der Betrag in der Kasse bzw. auf der Rechnung. Rundungsdifferenzen im Cent-Bereich sind möglich.';
      root._thuAnzeige = istAngebot ? null : { je_lizenz_netto: Math.round(jeNetto) / 100, summe_netto: summeNetto / 100, ust: ust / 100, summe_brutto: (summeNetto + ust) / 100, rabatt_prozent: r * 100 };
    }

    /* ---------- Validierung ---------- */
    function fehlerSetzen(name, text) {
      var box = $(root, '[data-fehler="' + name + '"]');
      var feld = form.elements[name];
      if (box) { box.hidden = !text; var t = $(box, '[data-th-v2-fehler-text]'); if (t) t.textContent = text || ''; if (!box.id) box.id = 'thu-f-' + name + '-' + Math.random().toString(36).slice(2, 7); }
      if (feld && feld.setAttribute) {
        if (text) { feld.setAttribute('aria-invalid', 'true'); if (box) feld.setAttribute('aria-describedby', box.id); } else { feld.removeAttribute('aria-invalid'); }
      }
    }
    var MELDUNG = {
      firma: 'Bitte geben Sie Ihre Firma bzw. Einrichtung an.',
      vorname: 'Bitte geben Sie Ihren Vornamen an.',
      nachname: 'Bitte geben Sie Ihren Nachnamen an.',
      email: 'Bitte geben Sie eine gültige E-Mail-Adresse an.',
      strasse: 'Bitte geben Sie Straße und Hausnummer an.',
      plz: 'Bitte geben Sie die Postleitzahl an.',
      ort: 'Bitte geben Sie den Ort an.',
      unternehmer: 'Bitte bestätigen Sie, dass Sie als Unternehmen bzw. Einrichtung bestellen.'
    };
    function pruefen() {
      var ok = true, erstes = null;
      Object.keys(MELDUNG).forEach(function (k) {
        var f = form.elements[k];
        if (!f || f.disabled) { fehlerSetzen(k, ''); return; }
        var leer = f.type === 'checkbox' ? !f.checked : !String(f.value).trim();
        var bad = leer || (k === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.value.trim()));
        fehlerSetzen(k, bad ? MELDUNG[k] : '');
        if (bad) { ok = false; erstes = erstes || f; }
      });
      if (modus === 'teamlizenz') {
        if (!produkt) { fehlerSetzen('kurs_handle', 'Bitte wählen Sie einen Online-Testtrainer.'); ok = false; erstes = erstes || suche; } else fehlerSetzen('kurs_handle', '');
        var n = menge();
        var st = stufe(n);
        var istAngebot = !!(st && st.angebot);
        if (!istAngebot && n < minMenge && !rcEinzel()) { fehlerSetzen('anzahl', 'Teamlizenzen gibt es ab ' + minMenge + ' Lizenzen.'); ok = false; erstes = erstes || anzahl; } else fehlerSetzen('anzahl', '');
        var id = (ustid.value || '').replace(/[\s.-]/g, '').toUpperCase();
        if (id && !/^[A-Z]{2}[0-9A-Z]{2,13}$/.test(id) && land.value !== 'XX' && land.value !== 'CH' && land.value !== 'LI') { fehlerSetzen('ust_id', 'Bitte prüfen Sie die USt-IdNr. (Länderkürzel und Nummer, z. B. DE123456789).'); ok = false; erstes = erstes || ustid; } else fehlerSetzen('ust_id', '');
      }
      if (erstes) erstes.focus();
      return ok;
    }

    /* ---------- Absenden ---------- */
    $$(form, 'button[type="submit"]').forEach(function (b) {
      b.addEventListener('click', function () { aktion = b.getAttribute('data-aktion'); });
    });
    function statusZeigen(text, art) {
      status.hidden = !text;
      status.className = 'th-form__status thu-status' + (art ? ' thu-status--' + art : '');
      status.textContent = text || '';
    }
    function sicherUrl(u) {
      try {
        var x = new URL(u);
        return x.protocol === 'https:' && /(^|\.)(testhelden\.com|myshopify\.com|shopify\.com)$/.test(x.hostname) ? x.href : null;
      } catch (e) { return null; }
    }
    function daten() {
      var f = form.elements;
      var d = {
        art: modus,
        firma: f.firma.value.trim(),
        vorname: f.vorname.value.trim(),
        nachname: f.nachname.value.trim(),
        email: f.email.value.trim(),
        telefon: f.telefon.value.trim(),
        land: f.land.value,
        unternehmerBestaetigt: f.unternehmer.checked,
        bedingungenAkzeptiert: f.unternehmer.checked,
        bedingungen: root.getAttribute('data-bedingungen'),
        quelle: location.href.slice(0, 500),
        website: f.website.value,
        formStart: formStart
      };
      if (modus === 'teamlizenz') {
        d.variantId = variante ? String(variante.id) : '';
        d.kurs_handle = f.kurs_handle.value;
        d.anzahl = menge();
        // Ab 50 Lizenzen entscheidet die Plattform auf Angebot; zahlweg ist trotzdem Pflicht.
        d.zahlweg = aktion === 'bezahlen' ? 'sofort' : 'rechnung';
        d.strasse = f.strasse.value.trim();
        d.plz = f.plz.value.trim();
        d.ort = f.ort.value.trim();
        d.ustId = f.ust_id.value.replace(/\s+/g, '').toUpperCase();
        d.bestellnummer = f.kostenstelle.value.trim();
        d.oeffentlicheEinrichtung = f.oeffentlich.checked;
        d.preisAnzeige = root._thuAnzeige || null;
        d.nachricht = '';
      } else {
        var bew = parseInt(f.anzahl_assessment.value, 10) || 0;
        d.nachricht = [bew ? 'Bewerbende/Prüflinge pro Jahr (ca.): ' + bew : '', f.start.value.trim() ? 'Gewünschter Start: ' + f.start.value.trim() : '', f.nachricht.value.trim()].filter(Boolean).join('\n');
      }
      return d;
    }
    function mailRueckfall(d) {
      var zeilen = [
        'Anfrage über testhelden.com/pages/unternehmen',
        'Art: ' + (d.art === 'assessment' ? 'Online-Assessment' : 'Teamlizenzen'),
        d.kurs_handle ? 'Kurs: ' + d.kurs_handle + (d.variantId ? ' (Variante ' + d.variantId + ')' : '') : '',
        d.anzahl ? 'Anzahl: ' + d.anzahl : '',
        'Firma: ' + d.firma, 'Ansprechpartner: ' + d.vorname + ' ' + d.nachname, 'E-Mail: ' + d.email,
        d.strasse ? 'Anschrift: ' + d.strasse + ', ' + d.plz + ' ' + d.ort + ', ' + d.land : 'Land: ' + d.land,
        d.ustId ? 'USt-IdNr.: ' + d.ustId : '', d.bestellnummer ? 'Kostenstelle: ' + d.bestellnummer : '',
        d.nachricht || ''
      ].filter(Boolean).join('\n');
      return 'mailto:' + mail + '?subject=' + encodeURIComponent('B2B-Anfrage ' + d.firma) + '&body=' + encodeURIComponent(zeilen);
    }
    function danke(antwort, d) {
      var titel, text, schritte;
      if (antwort.modus === 'rechnung') {
        titel = 'Vielen Dank, Ihre Bestellung ist angelegt.';
        text = 'Die Rechnung mit Bankverbindung und Verwendungszweck senden wir an ' + (antwort.email || d.email) + '.';
        schritte = ['Rechnung prüfen und überweisen (Verwendungszweck: Ihre Bestellnummer).', 'Nach Zahlungseingang schalten wir Ihre Lizenzen frei.', 'Sie erhalten den Zugang zum Coach-Bereich und verteilen die Lizenzen per Link oder E-Mail.'];
      } else {
        titel = 'Vielen Dank, Ihre Anfrage ist eingegangen.';
        if (d.art === 'assessment') {
          text = 'Wir melden uns per E-Mail bei Ihnen, um einen Termin für die Online-Demo (20 bis 30 Minuten) abzustimmen.';
          schritte = ['Online-Demo: Coach-Bereich, Bewerberansicht und Auswertung.', 'Individuelles Angebot nach Umfang und Teilnehmerzahl.', 'Einrichtung Ihres Online-Assessments mit Zugangscodes.'];
        } else {
          text = 'Wir haben Ihre Angaben erhalten und senden Ihnen das Angebot bzw. die Rechnung mit dem Staffelpreis per E-Mail an ' + d.email + '.';
          schritte = ['Prüfung Ihrer Angaben durch unser Team.', 'Angebot bzw. Rechnung mit Zahlungslink oder Bankverbindung per E-Mail.', 'Nach der Zahlung: Zugang zum Coach-Bereich und Lizenzen verteilen.'];
        }
      }
      $(root, '[data-thu-danke-titel]').textContent = titel;
      $(root, '[data-thu-danke-text]').textContent = antwort.meldung || text;
      $(root, '[data-thu-danke-ref]').textContent = antwort.referenz || '–';
      $(root, '[data-thu-danke-ref]').parentNode.hidden = !antwort.referenz;
      var ul = $(root, '[data-thu-danke-schritte]');
      ul.innerHTML = '';
      schritte.forEach(function (s, i) { var li = document.createElement('li'); var b = document.createElement('span'); b.className = 'thu-danke__nr'; b.textContent = i + 1; li.appendChild(b); li.appendChild(document.createTextNode(s)); ul.appendChild(li); });
      form.hidden = true;
      $(root, '.thu-modus').hidden = true;
      var box = $(root, '[data-thu-danke]');
      box.hidden = false;
      box.focus();
      box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    function melden(ereignis, extra) {
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: ereignis }, extra || {})); } catch (e) {}
    }
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sendet) return;
      statusZeigen('');
      if (!pruefen()) { statusZeigen('Bitte prüfen Sie die markierten Felder.', 'fehler'); return; }
      var d = daten();
      var knopf = $(form, 'button[data-aktion="' + d.aktion + '"]') || $(form, 'button[type="submit"]:not([hidden])');
      sendet = true;
      $$(form, 'button[type="submit"]').forEach(function (b) { b.disabled = true; });
      if (knopf) knopf.classList.add('is-loading');
      statusZeigen(d.aktion === 'bezahlen' ? 'Ihre Bestellung wird vorbereitet …' : 'Wird gesendet …', 'laeuft');
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 25000);
      fetch(endpunkt, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(d), signal: ctrl ? ctrl.signal : undefined, credentials: 'omit' })
        .then(function (r) { return r.json().catch(function () { return { ok: false, fehler: 'intern', http: r.status }; }).then(function (j) { j.http = r.status; return j; }); })
        .then(function (a) {
          clearTimeout(t);
          if (a && a.ok) {
            melden('th_b2b_absenden', { th_b2b_modus: a.modus, th_b2b_art: d.art, th_b2b_anzahl: d.anzahl });
            var ziel = sicherUrl(a.checkoutUrl || a.weiterleitung || '');
            if (ziel) { statusZeigen('Sie werden zur sicheren Kasse weitergeleitet …', 'laeuft'); window.location.assign(ziel); return; }
            if (a.modus === 'entwurf' || a.modus === 'kasse') a.modus = (a.zahlweg === 'sofort' || d.zahlweg === 'sofort') ? 'anfrage' : 'rechnung';
            danke(a, d);
            return;
          }
          var felder = (a && a.felder) || {};
          var FELD = { variantId: 'kurs_handle', ustId: 'ust_id', unternehmerBestaetigt: 'unternehmer', bedingungenAkzeptiert: 'unternehmer', bestellnummer: 'kostenstelle', zahlweg: '' };
          if (a && a.feld) { var fk = a.feld in FELD ? FELD[a.feld] : a.feld; if (fk) felder[fk] = a.fehler || 'Bitte prüfen.'; }
          Object.keys(felder).forEach(function (k) { fehlerSetzen(k, felder[k]); });
          var text = (a && (a.meldung || (typeof a.fehler === 'string' && a.fehler.length > 12 ? a.fehler : ''))) || (a && a.http === 429 ? 'Zu viele Versuche in kurzer Zeit. Bitte warten Sie einen Moment.' : 'Das hat leider nicht geklappt. Bitte versuchen Sie es erneut oder schreiben Sie uns.');
          throw { anzeige: text, keinRueckfall: Object.keys(felder).length > 0 };
        })
        .catch(function (err) {
          clearTimeout(t);
          var text = (err && err.anzeige) || 'Die Verbindung hat nicht geklappt. Bitte versuchen Sie es erneut.';
          statusZeigen(text, 'fehler');
          if (!(err && err.keinRueckfall)) {
            var a = document.createElement('a');
            a.href = mailRueckfall(d);
            a.textContent = ' Alternativ per E-Mail senden.';
            status.appendChild(a);
          }
          melden('th_b2b_fehler', { th_b2b_art: d.art });
        })
        .then(function () {
          sendet = false;
          $$(form, 'button[type="submit"]').forEach(function (b) { b.disabled = false; b.classList.remove('is-loading'); });
          rechnen();
        });
    });

    /* ---------- Staffel und Sofortkauf von der Plattform (GET /api/mobile/b2b/staffel, SSoT) ---------- */
    function sofortkaufSetzen(an) {
      var b = $(root, 'button[data-aktion="bezahlen"] span');
      if (b) b.textContent = an ? 'Jetzt bezahlen' : 'Zahlungslink anfordern';
      var z = $(root, '[data-thu-zahlweg-sofort]');
      if (z) z.innerHTML = an ? '<strong>Jetzt bezahlen:</strong> sichere Shopify-Kasse mit Karte, PayPal, Apple Pay, Google Pay oder Klarna. Freischaltung direkt nach der Zahlung.'
        : '<strong>Zahlungslink anfordern:</strong> Sie erhalten den Link zur sicheren Shopify-Kasse (Karte, PayPal, Apple Pay, Google Pay oder Klarna) per E-Mail. Freischaltung direkt nach der Zahlung.';
    }
    try {
      fetch(endpunkt.replace(/\/entwurf\/?$/, '/staffel'), { headers: { Accept: 'application/json' }, credentials: 'omit' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j || !j.staffel || !j.staffel.length) return;
          var neu = j.staffel.map(function (t) { return { ab: t.ab, angebot: false, rabatt: t.rabattProzent }; });
          if (j.angebotAb) neu.push({ ab: j.angebotAb, angebot: true, rabatt: 0 });
          staffel = neu.sort(function (a, b) { return a.ab - b.ab; });
          if (j.mindestmenge) minMenge = j.mindestmenge;
          // Kacheln an die Plattform angleichen (Reihenfolge = Stufen)
          var lis = $$(sec, '[data-thu-staffel-liste] .thu-staffel__stufe');
          if (lis.length === staffel.length) staffel.forEach(function (t, i) {
            lis[i].setAttribute('data-ab', t.ab);
            var w = $(lis[i], '.thu-staffel__wert');
            if (w && !t.angebot) w.textContent = '−' + t.rabatt.toLocaleString('de-DE') + '\u00a0%';
          });
          sofortkaufSetzen(j.sofortkauf === true);
          rechnen();
        }).catch(function () {});
    } catch (e) {}

    /* ---------- Start: URL-Parameter ?kurs=…&anzahl=…&paket=…, #assessment-anfrage ---------- */
    var p = new URLSearchParams(location.search);
    if (p.get('anzahl')) anzahl.value = Math.max(1, parseInt(p.get('anzahl'), 10) || minMenge);
    modusSetzen(location.hash === '#assessment-anfrage' || p.get('art') === 'assessment' ? 'assessment' : 'teamlizenz');
    if (p.get('kurs')) kursLaden(p.get('kurs'), p.get('paket'));
    // Nachkauf aus dem Coach-Bereich: ?variante=<Varianten-ID>&firma=<Firmenname>#teamlizenzen
    // (/variants/<id> leitet auf /products/<handle>?variant=<id> weiter, HEAD reicht für den Handle)
    var vParam = (p.get('variante') || '').replace(/\D/g, '');
    if (vParam && !p.get('kurs')) {
      fetch('/variants/' + vParam, { method: 'HEAD', redirect: 'follow', credentials: 'same-origin' })
        .then(function (r) { var m = /\/products\/([^/?#]+)/.exec(r.url || ''); if (m) kursLaden(decodeURIComponent(m[1]), vParam); })
        .catch(function () {});
    }
    if (p.get('firma') && form.elements.firma && !form.elements.firma.value) form.elements.firma.value = p.get('firma').slice(0, 120);
    rechnen();
  }

  function start() { document.querySelectorAll('[data-thu-strecke]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
